const UPLOADS = [
  { name: 'project_0801.mp4', size: '4.2 GB', progress: '88%' },
  { name: 'bts_cut_02.mov', size: '1.8 GB', progress: '100%' },
] as const

export function LandingUploadVisual() {
  return (
    <div className="landing-fade-in landing-fade-in-delay-2 relative">
      <div aria-hidden className="absolute -inset-8 rounded-full bg-primary/20 blur-3xl" />
      <div className="relative overflow-hidden rounded-[28px] border border-white/10 bg-zinc-950 p-5 shadow-2xl shadow-primary/20 sm:p-7">
        <VisualHeader />
        <div className="space-y-3">
          {UPLOADS.map((upload) => (
            <UploadRow key={upload.name} {...upload} />
          ))}
        </div>
        <div className="mt-4 flex items-center gap-3 rounded-2xl bg-white p-3.5 text-left shadow-lg">
          <span className="flex size-9 shrink-0 items-center justify-center rounded-xl bg-primary/10 text-lg font-bold text-primary">
            ↗
          </span>
          <div className="min-w-0">
            <p className="text-[10px] font-semibold uppercase tracking-widest text-muted-foreground">
              共有リンクを発行しました
            </p>
            <p className="mt-0.5 truncate font-mono text-xs text-foreground">
              terafile.jp/s/9fa2c1
            </p>
          </div>
        </div>
      </div>
    </div>
  )
}

function VisualHeader() {
  return (
    <div className="mb-5 flex items-center gap-2">
      <span className="size-2.5 rounded-full bg-primary" />
      <span className="size-2.5 rounded-full bg-white/20" />
      <span className="size-2.5 rounded-full bg-white/20" />
      <span className="ml-auto font-mono text-[10px] tracking-widest text-white/50">UPLOAD</span>
    </div>
  )
}

function UploadRow({ name, size, progress }: (typeof UPLOADS)[number]) {
  return (
    <div className="rounded-2xl border border-white/10 bg-white/[0.06] p-4">
      <div className="mb-3 flex justify-between gap-3 font-mono text-[11px] text-white/75">
        <span className="truncate">{name}</span>
        <span className="shrink-0">{size}</span>
      </div>
      <div className="h-2 overflow-hidden rounded-full bg-white/10">
        <div
          className="landing-upload-flow h-full rounded-full bg-gradient-primary"
          style={{ width: progress }}
        />
      </div>
    </div>
  )
}
